"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var VendorCompanyDropdownOptionType;
(function (VendorCompanyDropdownOptionType) {
    VendorCompanyDropdownOptionType[VendorCompanyDropdownOptionType["All"] = 0] = "All";
    VendorCompanyDropdownOptionType[VendorCompanyDropdownOptionType["Transportation"] = 1] = "Transportation";
    VendorCompanyDropdownOptionType[VendorCompanyDropdownOptionType["Hotel"] = 2] = "Hotel";
})(VendorCompanyDropdownOptionType || (VendorCompanyDropdownOptionType = {}));
exports.default = VendorCompanyDropdownOptionType;
